<template>
    <div>
        <nav class="mui-bar mui-bar-tab">
            <a class="mui-tab-item" external v-link="{ path: '/index', activeClass: 'mui-active'}">
                <i class="mui-icon mui-icon-home"></i>
                <span class="mui-tab-label">首页</span>
            </a>
            
            <a style="display:none;" class="mui-tab-item" external v-link="{ path: '/products',activeClass: 'mui-active' }">
                <i class="mui-icon mui-icon-product"></i>
                <span class="mui-tab-label">产品</span>
                <!-- <div class="mui-center-cycle"></div>
                <div class="mui-center-text">
                    <i class="mui-invest-icon"></i>
                    <span class="mui-tab-label">投资</span>
                </div> -->
            </a>
            <a style="display:none;" class="mui-tab-item" external v-link="{ path: '/find',activeClass: 'mui-active' }">
                <i class="mui-icon mui-icon-find"></i>
                <span class="mui-tab-label">发现</span>
            </a>
            <a class="mui-tab-item" href="javascript:;" v-link="{ path: '/help',activeClass: 'mui-active' }" > <!--@click="kefu();"-->
                <i class="mui-icon mui-icon-kefu"></i>
                <span class="mui-tab-label">客服</span>
            </a>
            <a class="mui-tab-item" external  v-link="{ path: session ? '/retreat' : '/login' ,activeClass: 'mui-active' }">
                <i class="mui-icon mui-icon-account"></i>
                <span class="mui-tab-label">我的</span>
            </a>
        </nav>
        <!-- 缓存一级路由切换的页面 -->
        <router-view></router-view>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                token: '',
                session: false,
                clearout: false,
                isplus: false
            }
        },
        created: function(){
            var _self = this;
            mui.plusReady(function() {
                _self.isplus = true;
                mui.WebView.initTemplates('default');
            });
        },
        methods:{
            kefu: function(){
                if(this.isplus){
                    mui.WebView.Open({'href': 'http://sjjz.udesk.cn/im_client?web_plugin_id=23638', 'title': '在线客服'},'default');
                }else{
                    top.window.location.href = 'http://sjjz.udesk.cn/im_client?web_plugin_id=23638';
                }
            }
        }
    }
</script>






// WEBPACK FOOTER //
// enter.vue?72ca69fa